import * as React from "react";
import { forwardRef } from "react";
const SvgChartPie = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10 3.2A9 9 0 1 0 20.8 14a1 1 0 0 0-1-1H13a2 2 0 0 1-2-2V4a.9.9 0 0 0-1-.8" }), /* @__PURE__ */ React.createElement("path", { d: "M15 3.5A9 9 0 0 1 20.5 9H16a1 1 0 0 1-1-1z" }));
const ForwardRef = forwardRef(SvgChartPie);
export default ForwardRef;
